/**
 * Bug 34319: the Sparta API logs a report open (ReportStatistics) on `/access` only. The first
 * embed uses `/access`; the hourly session-renewal re-embed uses `/refresh` so it is not counted
 * as another open.
 */
export function spartaReportAccessUrl(
  paginatedReportId: string,
  refresh: boolean
): string {
  return `/api/report/${paginatedReportId}/${refresh ? 'refresh' : 'access'}`;
}
